(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign_galery_single"] && !Shopify.designMode) return;
  try {
    
/* Minimal JavaScript - only handles pinning behavior, no programmatic snapping */
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-cc2-section]');
  if (!sections.length) return;

  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  sections.forEach((section) => {
    if (section.dataset.cc2Init) return;
    section.dataset.cc2Init = 'true';

    const fullHeight = (section.getAttribute('data-height') || 'full') === 'full';

    // Pin when desktop + Full height
    const updatePin = () => {
      if (isDesktop() && fullHeight) {
        section.classList.add('is-pinned');
      } else {
        section.classList.remove('is-pinned');
      }
    };

    updatePin();
    window.addEventListener('resize', updatePin, { passive: true });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign_gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('.campaign-carousel');
  if (!carousel || window.innerWidth < 990) return;

  let isDown = false;
  let startX, scrollLeft;

  carousel.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
    carousel.classList.add('active');
  });

  carousel.addEventListener('mouseleave', () => {
    isDown = false;
    carousel.classList.remove('active');
  });

  carousel.addEventListener('mouseup', () => {
    isDown = false;
    carousel.classList.remove('active');
  });

  carousel.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 1;
    carousel.scrollLeft = scrollLeft - walk;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'smooth' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
